
import {
    SEARCH_LIST_ATTEMPT,
    SEARCH_LIST_SUCCESS,
    SEARCH_LIST_FAILED

} from '../types/adSearchTypes';

const INITIAL_STATE = {
    loading: false,
    list: [],
    page_size: 0,
    page_count: 0,
    query: '',
    error: '',
};
function adSearch(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SEARCH_LIST_ATTEMPT:
            return {
                ...state,
                loading: true,
                query: action.query || state.query,
                page_count: 0,
                list: [],
            }

        case SEARCH_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.data.list,
                page_size: action.data.size,
                page_count: action.data.size,
                query: action.query || state.query,
                error: ''
            }

        case SEARCH_LIST_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                list: [],
                page_count: 0,
            }

        default: return state;
    }
};
export default adSearch;
